import { useNavigate } from "react-router-dom"
import { CloseOrange, Setup } from "../../common/atoms/Icons/Chat"
import { IconButton } from "../common/IconButton/IconButton"
import styles from "./MessageProfileAlert.module.scss"

type Props = {
    show: boolean
    onClose: () => void
}

export const MessageProfileAlert: React.FC<Props> = ({ show, onClose }) => {
    const navigate = useNavigate()
    if (!show) return null

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation()
        onClose()
    }
    return (
        <div
            className={styles.messageProfileAlert}
            onClick={() => navigate("/settings")}
            data-testid="message-profile-alert"
        >
            <Setup height={20} width={32} className={styles.setupIcon} />
            <div className={styles.message}>
                <h2>Set up your message profile</h2>
                <p>
                    Once your profile is complete, you may be featured in the
                    message recommendation list.
                </p>
            </div>
            <IconButton
                icon={<CloseOrange height={14} width={14} />}
                iconAlt="Close"
                onClick={handleClose}
                className={styles.closeIcon}
            />
        </div>
    )
}
